<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form @submit.prevent="submit" v-promise-btn="{ action: 'submit' }">
          <div class="card container">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label for="origen" class="label">Origen</label>
                  <multiselect-item
                    id="origen"
                    v-model="origen"
                    track-by="id_ubic_cheque"
                    placeholder="Seleccione una cuenta"
                    :custom-label="label"
                    :options="origenOptions"
                  ></multiselect-item>
                </div>
              </div>
            </div>

            <div class="row" v-if="origen">
              <div class="col">
                <div
                  v-if="isChequesLoading"
                  class="d-flex justify-content-center align-items-center"
                >
                  Cargando cheques
                </div>
                <div v-else class="col-12 container">
                  <div class="row">
                    <div class="col">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th></th>
                            <th>BANCO</th>
                            <th>Número</th>
                            <th>Monto</th>
                            <th>Fecha</th>
                            <th>Emisor</th>
                            <th>Comentario</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="cheque in chequesOrigen"
                            :key="cheque.id_cheque"
                          >
                            <td>
                              <input
                                :id="`cheque-${cheque.id_cheque}`"
                                v-model="cheque.selected"
                                type="checkbox"
                              />
                            </td>
                            <td>
                              <label :for="`cheque-${cheque.id_cheque}`">{{
                                cheque.banco
                              }}</label>
                            </td>
                            <td>
                              <label :for="`cheque-${cheque.id_cheque}`">{{
                                cheque.id_cheque
                              }}</label>
                            </td>
                            <td>
                              <label :for="`cheque-${cheque.id_cheque}`">
                                <vue-numeric
                                  read-only
                                  currency="$"
                                  thousand-separator="."
                                  decimal-separator=","
                                  :precision="2"
                                  :value="cheque.cheque_monto"
                                ></vue-numeric>
                              </label>
                            </td>
                            <td>
                              <label :for="`cheque-${cheque.id_cheque}`">{{
                                formatFecha(cheque.fecha_cobro)
                              }}</label>
                            </td>
                            <td>
                              <label :for="`cheque-${cheque.id_cheque}`">{{
                                cheque.emisor
                              }}</label>
                            </td>
                            <td>
                              <label
                                :for="`cheque-${cheque.id_cheque}`"
                                style="max-width: 200px; font-size: 10px"
                                >{{ cheque.comentario }}</label
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card container" v-if="origen">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label for="destino" class="label">Destino</label>
                  <multiselect-item
                    id="destino"
                    v-model="destino"
                    track-by="id_ubicacion_dinero"
                    placeholder="Seleccione una cuenta"
                    :custom-label="(ubic) => `${ubic.ubicacion_dinero}`"
                    :options="destinoOptions"
                  ></multiselect-item>
                </div>
              </div>
            </div>
            <div class="row justify-content-center" v-if="destino">
              <div class="col-6">
                <div class="form-group">
                  <label for="destinoMonto" class="label"
                    >Total transferido</label
                  >
                  <vue-numeric
                    id="destinoMonto"
                    disabled
                    currency="$"
                    thousand-separator="."
                    decimal-separator=","
                    :precision="2"
                    class="form-control"
                    :value="destinoMonto"
                  ></vue-numeric>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="nuevoSaldo" class="label">Nuevo Saldo</label>
                  <vue-numeric
                    id="nuevoSaldo"
                    disabled
                    currency="$"
                    thousand-separator="."
                    decimal-separator=","
                    :precision="2"
                    class="form-control"
                    :value="destinoNuevoSaldo"
                    v-select-on-focus
                  ></vue-numeric>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <button class="btn btn-danger" type="button" @click="hideModal">
              Cancelar
            </button>
            <button class="btn btn-primary" type="submit">Confirmar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import stringToFloatMoneyParser from "@/lib/utils/stringToFloatMoneyParser";
import { formatM } from "@/lib/utils/accountingJsFns";
import axios from "axios";
import vueNumeric from "../../lib/utils/vue-numeric.vue";

export default {
  name: "MakeChequesTransaction",
  mixins: [stringToFloatMoneyParser],
  components: { vueNumeric },
  computed: {
    origenOptions() {
      return this.$store.getters["cuentas/getCuentasCheques"];
    },
    destinoOptions() {
      return this.$store.getters["ubicacionDinero/getUbicaciones"].filter(
        ({ id_ubicacion_dinero }) =>
          id_ubicacion_dinero.toString() !==
          this.origen.id_ubic_cheque.toString(),
      );
    },
    destinoNuevoSaldo() {
      let cuentaDestino = this.origenOptions.find(
        ({ id_ubic_cheque }) =>
          id_ubic_cheque.toString() ===
          this.destino.id_ubicacion_dinero.toString(),
      );
      if (cuentaDestino) {
        return (
          this.parsePotentiallyGroupedFloat(cuentaDestino.Total.toString()) +
          this.parsePotentiallyGroupedFloat(this.destinoMonto.toString())
        );
      } else return this.destinoMonto;
    },
    destinoMonto() {
      try {
        return this.chequesOrigen.reduce((carry, curr) => {
          if (curr.selected) {
            return parseFloat(carry) + parseFloat(curr.cheque_monto);
          }
          return carry;
        }, 0);
      } catch (e) {
        return 0;
      }
    },
  },
  data: () => ({
    origen: null,
    destino: null,
    chequesOrigen: [],
    isChequesLoading: true,
  }),
  watch: {
    origen() {
      this.getChequesOrigen();
    },
  },
  methods: {
    formatMoney(value) {
      return formatM(value);
    },
    chequeMontoParseado(monto) {
      return this.parsePotentiallyGroupedFloat(monto);
    },
    label(cuenta) {
      return `${cuenta.ubicacion_cheque} - TOTAL: ${this.formatMoney(
        cuenta.Total,
      )}`;
    },
    async submit() {
      let fd = new FormData();
      fd.append(
        "destino_id_ubicacion_dinero",
        this.destino.id_ubicacion_dinero,
      );
      fd.append(
        "cheques",
        this.chequesOrigen
          .filter((cheque) => cheque.selected)
          .map((cheque) => cheque.id_cheque)
          .join(","),
      );

      let resp = await axios.post("cheques/transferencia", fd);

      if (resp.data.ok) {
        this.$store.dispatch("cuentas/getCuentas");
        this.hideModal();
        setTimeout(() => {
          this.$nextTick(() => {
            this.$bvToast.toast(resp.data.message, {
              variant: "success",
            });
          });
        });
      } else {
        this.$bvToast.toast(resp.data.message, {
          variant: "danger",
        });
      }
    },
    hideModal() {
      this.$bvModal.hide("makeTransactionModal");
    },
    async getChequesOrigen() {
      this.isChequesLoading = true;
      let resp = await axios.get("/cheques", {
        params: {
          ubicacion: this.origen.id_ubic_cheque,
          pendientes: true,
        },
      });

      if (resp.data.ok) {
        this.chequesOrigen = resp.data.result;
        this.isChequesLoading = false;
      }
    },
    formatFecha(fecha) {
      return this.$moment(fecha).format("ddd DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.card .card-category,
.card td label {
  font-size: 14px;
  font-weight: 400;
  color: black;
  margin-bottom: 0px;
  cursor: pointer;
}
</style>
